<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="Select Vendor" v-if="visible" :model-value="visible"
      @update:modelValue="(val) => { if (!val) modal.closeVendor(); visible = val }" width="50%">
      <el-input v-model="searchQuery" placeholder="Search vendor name" @input="handleSearchInput"
        style="margin-bottom: 20px" />
      <el-button size="small" type="primary" style="margin-bottom: 10px" @click="handleVendorAdd">Add New</el-button>
      <el-table :data="vendorList" @row-click="handleSelect" stripe v-loading="listLoading"
        header-cell-class-name="my-header">
        <el-table-column prop="name" label="Vendor Name" />
        <!-- <el-table-column label="" align="right">
          <template #default="scope">
            <el-button v-if="scope" size="small" type="primary" @click.stop="handleSelect(scope.row)">Select</el-button>
          </template>
</el-table-column> -->
      </el-table>
      <template #footer>
        <el-button @click="modal.closeVendor(); visible = false">Cancel</el-button>
      </template>
    </el-dialog>

    <VendorFormDialog v-model:visible="addVisible" :row="null" @saved="handleVendorSaved" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { debounce } from 'lodash'
import { fetchList as fetchVendorList } from '@/api/vendor'
import { useFetch } from '@/composables/useFetch'
import { useModalStore } from '@/stores/modal'
import VendorFormDialog from '@/views/sms/vendor/components/VendorFormDialog.vue'

const modal = useModalStore()

const visible = ref(false)
const addVisible = ref(false)
const searchQuery = ref('')

const { data: vendorListData, loading: listLoading, fetch: fetchVendors } = useFetch(
  () => fetchVendorList({ keyword: searchQuery.value }),
  { extract: res => res.data.list || [], defaultValue: [] }
)

const vendorList = vendorListData

watch(() => modal.vendor.visible, async (val) => {
  if (val) {
    searchQuery.value = ''
    visible.value = true
    await fetchVendors()
  } else {
    visible.value = false
  }
}, { immediate: true })

const handleSearchInput = debounce(() => {
  fetchVendors()
}, 300)

function handleSelect(row) {
  modal.resolveVendor(row)
}

function handleVendorAdd() {
  addVisible.value = true
}

async function handleVendorSaved() {
  await fetchVendors()
}
</script>

<style scoped>
.my-header {
  font-weight: bold;
}
</style>
